import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const APIFY_REFRESH_ROLES = ['admin', 'manager', 'talent_manager', 'campaign_manager', 'account_executive'];

const FAIL_LABEL = { not_found: 'Instagram profile not found', no_result: 'No data returned', no_data: 'No data returned' };

// Triggers POST /api/creators/refresh-apify for given creator ids or all creators missing follower data.
export const ApifyRefreshButton = ({ creatorIds, allMissing = false, label, onDone, className = '', testid }) => {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    const tid = toast.loading(allMissing ? 'Starting refresh for creators missing data…' : 'Fetching live Instagram data… (up to a minute)');
    try {
      const body = allMissing ? { all_missing: true } : { creator_ids: creatorIds };
      const { data } = await axios.post(`${API_URL}/api/creators/refresh-apify`, body, { withCredentials: true });
      if (data.mode === 'background') {
        toast.success(data.message, { id: tid, description: 'Follower counts will fill in over the next few minutes.' });
      } else if (data.updated_count > 0) {
        toast.success(`Updated ${data.updated_count} creator${data.updated_count > 1 ? 's' : ''}`, { id: tid });
      } else {
        const reason = data.failed?.[0]?.reason;
        toast.error(FAIL_LABEL[reason] || data.message || 'Nothing was updated', { id: tid });
      }
      onDone?.(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Refresh failed', { id: tid });
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={run}
      disabled={busy}
      className={`rounded-full px-4 py-2 text-xs font-medium inline-flex items-center gap-1.5 transition-colors disabled:opacity-50 ${className}`}
      data-testid={testid}
    >
      {busy ? <Loader2 size={13} className="animate-spin" /> : <RefreshCw size={13} />}
      {busy ? 'Refreshing…' : label}
    </button>
  );
};
